module.exports = __webpack_public_path__ + "static/media/compliance_navigator_map.fa318c8c.svg";